import { MockUserName } from 'signer-app/signer-app-client/mock-signer-app-client';

export function makeLazyClient<
  T extends Record<string, any>,
  U extends Record<string, any>,
>(
  init: LazyInitaizlizer<T>,
  mockUserName: MockUserName,
  parent: U | null = null,
): T & U {
  const tmp = Object.create(parent);
  Object.assign(tmp, init);

  const client = new Proxy(tmp, {
    get(target, propKey, receiver) {
      const targetValue = Reflect.get(target, propKey, receiver);
      if (typeof targetValue === 'function') {
        const value = targetValue(mockUserName);
        // @ts-ignore
        target[propKey] = value;
        return value;
      }
      return targetValue;
    },
  });

  /**
   * The proxy will execute the function and replace it with its return value.
   * I don't see a good way to type this, so this function is typed properly to
   * represent the transform that's happening at runtime. But I have to end up
   * just casting it to the right type here.
   */
  return client as T & U;
}

export type LazyInitaizlizer<T extends object> = {
  [K in keyof T]: (name: MockUserName) => T[K];
};
